import React from "react";
import { getPageSetting } from "tsi-common-react/src/utils/settings";

import styles from "./index.module.scss";

// The basket-summary help box shared by the basket and checkout sidebars
// (BasketAppInner + CheckoutAppInner both render it). The phone number is read
// from page settings at render time.
export const BasketSidebarContent = (): React.JSX.Element => (
    <div className={styles.basketSummaryHelp}>
        {/* TODO(i18n): Use t tagged template: {t`Questions?`} */}
        <h3>Questions?</h3>
        <p className={styles.basketSummaryText}>
            {/* TODO(i18n): Use t with interpolation to keep sentence together: {t`Call ${phoneLink}.`} */}
            Call{" "}
            <a
                className={styles.basketSummaryPhoneLink}
                href={getPageSetting("pre_order_phone_number_link") || ""}
            >
                {getPageSetting("pre_order_phone_number_display") || ""}
            </a>
            .
        </p>
    </div>
);
